
import XHeader from 'vux/src/components/x-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'


export default {
components: {XHeader, Popup},
data() {
return {
showagree: false
}
},
methods: {
showpop() {
this.showagree = true
},
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/prohelp.vue